<script lang="ts">
    import {_} from '../services/i18n';
/*
    let cycles = [
        "#BBE0ED",
        "#6B99CD",
        "#4F7FB8",
        "#32639E",
        "#2F3353",
        "#4A7E83",
        "#4E7C67",
        "#6C8E51",
        "#A8B35B",
        "#C5C35A"
    ];
*/

</script>

<div class="legend">
    {#if mapType == 'full'}
        <div class="legend-item">
            <span class="my-auto"  style="margin-right:10px;">{$_('legend.community')}</span>
            <span class="legend-circle mark-light" style="background: #FAFAFA !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.selectedCommunity')}</span>
            <span class="legend-circle mark-selected-full" style="background: #FDEED6 !important; border-color:#F7A833 !important;"></span>
        </div>
    {:else }
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pilotPact')}</span>
            <span class="legend-circle mark-pilot-pact" style="background: #49b170 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pact')}</span>
            <span class="legend-circle mark-pact" style="background: #56A8DD !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.pactAndPilot')}</span>
            <span class="legend-circle mark-selected-mixed" style="background: repeating-linear-gradient(135deg, #56A8DD, #C8DBE7 6px, #C2E1CE 6px) !important; border-color: #428AB8 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.noPactCommunities')}</span>
            <span class="legend-circle mark-dark" style="background: #D0D0D0 !important;"></span>
        </div>
        <div class="legend-item">
            <span class="my-auto" style="margin-right:10px;">{$_('legend.selectedCommunity')}</span>
            <span class="legend-circle mark-selected-pilot-pact" style="background: #56A8DD !important; border-color:#428AB8 !important; margin-right:0.25rem !important;"></span>
            <span class="legend-circle mark-selected-pact" style="background: #C2E1CE !important; border-color:#449161 !important; margin-right:0.25rem !important;"></span>
            <span class="legend-circle mark-selected-mixed" style="background: repeating-linear-gradient(135deg, #56A8DD, #C8DBE7 6px, #C2E1CE 6px) !important; border-color: #428AB8 !important;"></span>
        </div>
       <!--
        <div class="legend-item group mobile-100">
            <span class="my-auto" style="margin-bottom:0.4rem!important;">{$_('legend.cycleInfo')}</span>
            <span class="cycle-wrapper">
                {#each cycles as cycle, index}
                 <span class="cycle-item">
                    <span class="legend-circle" style="background:{cycle}"></span>
                     <span class="cycle-label">{index++}</span>
                 </span>
                {/each}
            </span>

        </div>
        -->
    {/if}



</div>


<style lang="scss">

  .legend {
    /*min-width: max-content;*/
  }

  .legend-item {

    display: flex;

    margin-top: 1.5rem;
    align-items: center;
    //justify-content: space-between;


    &.group{

      flex-direction: column;
      margin-top: 1rem;
      align-items:start;

    }


    &:first-child{
      margin-top:0;
    }
  }



  .legend-circle {
    display: block;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0;
    border: 1px solid #054055;

  //  margin-top:0.4rem;
  }

  .cycle-wrapper {
    display: flex;
    //justify-content: end;
    flex: auto;
    flex-wrap: wrap;
    gap: 0.5rem;

    .cycle-item {

      display: flex;
      flex-direction: column;
      //margin: 0 0 0 0.5rem;
    }

    .cycle-label{
      text-align: center;
    }
  }

  /* Keep background color when printing*/
  /*
  color-adjust: exact;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  }
  */

  @media (max-width:680px) {

    .mobile-100{

        flex-direction: column;

      .cycle-wrapper{
         margin-top:1rem;

        .cycle-item:first-child{
          margin-left:0px;
        }
      }

    }

  }


  //alternative default?
  .mark-light {
    background: #FAFAFA;
  }

  //no pact community or default
  .mark-dark {
    background: #D0D0D0;//rgb(110, 110, 110);
  }

  .mark-pact {
    background: #56A8DD;

  }

  .mark-pilot-pact {
    background: #49b170;
  }

  .mark-selected {
    background: #D5E6F0;
  }


  .mark-selected-pilot-pact {
    background: #56A8DD;
    border-color:#428AB8;
    margin-right:0.25rem;
  }
  .mark-selected-pact {
    background: #C2E1CE;
    border-color:#449161;
    margin-right:0.25rem;
  }

  .mark-selected-mixed {
      background: repeating-linear-gradient(
                      135deg,
                      #56A8DD,
                      #C8DBE7 6px,
                      #C2E1CE 6px
      );
      border-color: #428AB8;
  }


  .mark-selected-full {
    background: #FDEED6;
    border-color:#F7A833 !important;
  }


  .mark-mixed-pact{

    background-image: linear-gradient(145deg, #ffffff 15%, #49b170 15%, #49b170 25%, #ffffff 25%, #ffffff 40%, #56a8dd 40%, #56a8dd 50%, #ffffff 50%, #ffffff 65%, #49b170 65%, #49b170 75%, #ffffff 75%, #ffffff 90%, #56a8dd 90%, #56a8dd 100%);
    background-size: 174.34px 122.08px;

  }

</style>
